module.exports = __webpack_public_path__ + "img/image8.23bff717.png";